const feedback = {
	banner: [{
		tips:'意见反馈',
		title:'意见反馈',
		content:'',
		img: require('@/assets/img/index/GPI_2x.png'),
		url: require('@/assets/img/index/banner01.png')
	}],	
	label:{
		company:'公司名称',
		name:'姓名',
		email:'邮箱',
		tel:'电话',
		info:'反馈信息',
		submit_btn:'提	交',
		rest_btn:'重	置'
	},
	placeholder:{
		company:'请输入公司名称',
		name:'请输入姓名',
		email:'请输入邮箱',
		tel:'请输入电话',
		info:'请输入反馈信息',
	},
	rules:{
		company:[{ required: true, message:'请输入公司名称', trigger: 'blur' },],
		name:[{ required: true, message:'请输入姓名', trigger: 'blur' },],
		email:[
			{ required: true, message:'请输入邮箱', trigger: 'blur' },
			{ pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, message: "请输入正确的邮箱地址", trigger: ["blur", "change"]}
		],
		tel:[
			{ required: true, message:'请输入电话', trigger: 'blur' },
			{ pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: "请输入正确的电话号码",trigger: "blur"}
		],
		info: [{ required: true, message:'请输入反馈信息', trigger: 'blur' },],
	}
	
}

export default feedback